const Testi = {
    Testi:[
        {
            id:1,
            clientName:'Steve Dampf',
            email:'steved868@gmail.com',
            desc:'"Vinsen, My brother thank you for all of your assistance in this We do appreciate it and we will have to take you out for a good meal next time we are in Bali. Stay well."',
        },
        {
            id:2,
            clientName:'Ayu from UK',
            email:'SHEREENWALLACERAHAYU@gmail.com',
            desc:'"Pak terima kasih banyak. Berkat bapak saya skrg udah di posisi aman. Saya kan waktu itu urus sama lawyer Pakistan. Terus kena tipu sama Pakistan itu. Dan bapak kasi saya contact kak maryam nah dia kasi saya lawyer dia. Setelah nunggu hampir 5 bulan karna covid visa fiance saya di approved. Tp saya udah apply 2 minggu sebelum mati visa visitor saya. Bapak org baik. Semoga makin success ya pak. Dan sehat selalu. Terima kasih sekali lagi ?????? jarang sekali saya ketemu agent yg tolong sampai ke titik ini. 2 banding 100 mgkn."',
        },
        {
            id:3,
            clientName:'Davids Father',
            email:'leon.ballis60@bigpond.com',
            desc:'"Your a champion mate a gift coming your way thank u mate see ya when I come over 🙏"',
        },
        {
            id:4,
            clientName:'Nitya Sabesti',
            email:'nityasabesi03@gmail.com',
            desc:'Terimakasih banyak atas bantuan bcsvisa, ini pertama kali saya membuat visa dan berhasil🥺🙏'
        },
        {
            id:5,
            clientName:'Bruce & Yan',
            email:'mcclarenb@yahoo.com',
            desc:'That’s fantastic! Thank you sir 🙏. Great job! 😃 😃. Hve u let yhan know yet or can i tell her and surprise her?\nAll good! She called me! Thanks again mate! We both very happy'
        },
        {
            id:6,
            clientName:'Michael Boyer',
            email:'mickboyer50@gmail.com',
            desc:'Thank you so much for all your help and patience with Maria and myself we are both very greatful and can’t wait for Maria to see Australia thanks you so much 🙏🏻'
        },
        {
            id:7,
            clientName:'Jodie Koch',
            email:'jodie.koch@hotmail.com',
            desc:'Hi Vinsen, sorry it take me awhile to message.. I just wanted to say a big thank you for all your help for visa and passport.. we appreciate it so much and are so grateful🙏'
        },
        {
            id:8,
            clientName:'Made Coblyn',
            email:'made.coblyn@gmail.com',
            desc:'Thank you so much for all of your help with the application of my sisters visa🙏 we greatly appreciate all of your hard work Mr Vinsen. We wish you all the best 🙏😊'
        },
        {
            id:9,
            clientName:'Andrew',
            email:'andrew@brazilianaussiebbq.com',
            desc:'Hi Vincen ,\n Ok I will let you know but yes same as always I buy a 12 month policy so can travel outside Indonesia easy, \n Also thank for the visa success, I bet you would never guess 3 multiple entry for brother and sister.'
        },
        {
            id:10,
            clientName:'Our Client at Empire Beauty Bali',
            email:'empirebeutybali@gmail.com',
            desc:'Thank you mas Vinsen for your hand.\n Well done and great job 😇,\n finally can visit my family'
        },
        {
            id:11,
            clientName:'Giofanny & Sean',
            email:'rennygeofani96@gmail.com',
            desc:'Thank you Jesus, ga lupa bawa dalam doa bli. Tuhan Yesus baik sekali masih ga nyangka, sampai ibunya sean juga nangis denger visa aku di terima😭😭😭\nTerimakasih juga buat doa baiknya bli, semoga doa baiknya kembali ke bli ya aminn. Terimakasih juga sudah bersedia membantu visa saya bli, luar biasa sekali Tuhan ini, hampir 2minggu langsung di acc.😭🥺\nGod bless ya bli. Thank you so muchhhh🙏'
        },
        {
            id:12,
            clientName:'Capt Jelle',
            email:'capt.jelle@gmail.com',
            desc:'Hi Vincen\n\nWell done, my thanks for this swift service.\nDo you do Shenzen Visa as well for Europe ?\n\nLet me know soonest\n\nBest regards\nCapt Jelle'
        },
        {
            id:13,
            clientName:'Chelsea Thompson',
            email:'admin@wattletreecountryretreat.com.au',
            desc:'A BIG hello Vincent,\n\nI am so happy… Thank you so much for your service 😊 Next visit to Bali I will bring you a very good gift XX Thank you so so much\n\nThank you'
        },
        {
            id:14,
            clientName:'Mrs. Jacky',
            email:'jackel@iinet.net.au',
            desc:'Thank you Vinsen. Your Visa service has been excellent.'
        }
    ]
}
export default Testi
